import fetch from '@/utils/fetch'
import { wymsFetch } from '@/utils/fetch'
//参数处理函数
function formatParams(args) {
	let params = new URLSearchParams()
	Object.entries(args).forEach(([key, value]) => {
		params.append(key, value)
	})
	return params
}
// 查询应用
export function queryModuleList(args) {
	return wymsFetch({
		url: 'moduleRolePerm/queryModuleList',
		method: 'post'
	})
}
// 添加模块
export function insertModuleHelp(args) {
	return fetch({
		url: 'structure/moduleHelp/insertModuleHelp',
		method: 'post',
		data: formatParams(args)
	})
}
//分页查询模块
export function queryModuleHelp(args) {
	return fetch({
		url: 'structure/moduleHelp/queryModuleHelp',
		method: 'post',
		data: formatParams(args)
	})
}
//删除模块
export function deleteModuleHelpById(args) {
	return fetch({
		url: 'structure/moduleHelp/deleteModuleHelpById',
		method: 'post',
		data: formatParams(args)
	})
}
//编辑模块
export function editModuleHelp(args) {
	return fetch({
		url: 'structure/moduleHelp/editModuleHelp',
		method: 'post',
		data: formatParams(args)
	})
}
//模块公开
export function showModuleHelpById(args) {
	return fetch({
		url: 'structure/moduleHelp/showModuleHelpById',
		method: 'post',
		data: formatParams(args)
	})
}
//添加手册
export function insertModuleHelpManual(args) {
	return fetch({
		url: 'structure/moduleHelp/insertModuleHelpManual',
		method: 'post',
		data: formatParams(args)
	})
}
//编辑手册
export function editModuleHelpManual(args) {
	return fetch({
		url: 'structure/moduleHelp/editModuleHelpManual',
		method: 'post',
		data: formatParams(args)
	})
}
//查询手册列表
export function getManualByModuleHelpId(args) {
	return fetch({
		url: 'structure/moduleHelp/getManualByModuleHelpId',
		method: 'post',
		data: formatParams(args)
	})
}
//删除手册
export function deleteModuleHelpManualById(args) {
	return fetch({
		url: 'structure/moduleHelp/deleteModuleHelpManualById',
		method: 'post',
		data: formatParams(args)
	})
}



// WEBPACK FOOTER //
// ./src/api/userManual.js